var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#15C33B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M26.412 6.98c-.256 2.521-.868 6.026-2.331 8.172H5.436C3.972 13.006 3.36 9.502 3.105 6.98c.226-.02.44-.082.636-.174a5.423 5.423 0 0 0 9.994-2.259 1.9 1.9 0 0 0 1.023.295c.377 0 .728-.108 1.024-.295a5.423 5.423 0 0 0 9.994 2.259c.195.092.41.153.636.174"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#15C33B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M16.679 2.921a1.92 1.92 0 1 1-3.84.001 1.92 1.92 0 0 1 3.84 0M4.842 5.068A1.921 1.921 0 1 1 1 5.07a1.921 1.921 0 0 1 3.842 0M28.517 5.068a1.921 1.921 0 1 1-3.843 0 1.921 1.921 0 0 1 3.843 0M24.08 15.152v2.825H5.437v-2.825"
  })));
};
export default SvgCrown;